
import { ButtonFieldConfig, DisplayTranformation, DynamicFormArray, FormFieldConfig } from './form.model';
import { AreaDropdown, defaultSearchContainerButtons, CertifiableRolesDropdown, DealerDropdown, NonCertifiableRolesDropdown, FieldNames, CertificationDropdown } from './form-fields.model';
import { DataTableSchema, DefaultTableSchema } from './dynamic-data-table.model';
import { FETCH_METHODS, SearchConfig } from './api.model';
import { OptionsFetchConfig } from './common.model';


const FormFieldArray: FormFieldConfig[] = structuredClone([
    { ...structuredClone(AreaDropdown), defaultValue: ['31', '32', '33', '34'] }, 
    { ...structuredClone(CertifiableRolesDropdown), isLoading: true},
    { ...structuredClone(NonCertifiableRolesDropdown), isLoading:true,displayTranformation: DisplayTranformation.none,isDependentOn: FieldNames.CertifiableRoles },
    { ...structuredClone(DealerDropdown),  isLoading: true, isAutoComplete: true}, 
    { ...structuredClone(CertificationDropdown), disabled: true, isDependentOn: FieldNames.CertifiableRoles }]);

const FormButtonArray: ButtonFieldConfig[] = structuredClone(defaultSearchContainerButtons);

export const JobRSummaryTitle = "Job Role Summary";

export const JobRoleSummaryDynamicOptionFields: OptionsFetchConfig = {
    fields: [
        { name: FieldNames['CertifiableRoles'], keyValuePair: { fieldLabel: '', fieldValue: '' } },
        { name: FieldNames['NonCertifiableRoles'], keyValuePair: { fieldLabel: '', fieldValue: '' } },
        { name: FieldNames['DealerNumber'], keyValuePair: { fieldLabel: '', fieldValue: '' } }],
    searchConfig: {
        path: 'jobSummaryDropdown',
        method: FETCH_METHODS['Get'],
        body: {}
    }
}

export const searchGetConfig: SearchConfig = {
    method: FETCH_METHODS['Post'],
    path: 'jobEnrollmentSummary',
    body: {
        "area": "",
        "certifiableRoles": "",
        "nonCertifiableRoles": "",
        "dealerNumber": "",
        "certification": ""
    }
}


export const JobRoleSummaryFormArray: DynamicFormArray = {
    FieldsArray: FormFieldArray,
    ButtonsArray: FormButtonArray,
    searchConfig: searchGetConfig,
    autoSearchOnLoad: true,
    disableFieldsDuringLoad: false
}



export const JobRoleSummaryTableSchema: DataTableSchema = {
    ...structuredClone(DefaultTableSchema),
    columnSchema: [
        { label: "Area", fieldKey: "area" },
        { label: "Area Name", fieldKey: "areaname" },
        { label: "District", fieldKey: "district", hideColumn: true },
        { label: "Total Job Count", fieldKey: "total" },
        { label: "Primary Job Role Count", fieldKey: "primary_role" },
        { label: "Secondary Job Role Count", fieldKey: "non_primary" }

    ],
    isSearchRequired: true,
    searchInfo: {
        placeholder: 'Filter',
        filtarableSpecificFields: []
    },
    exportConfig: {
        fileName: 'Job_Role_Summary',
        exportMessage: JobRSummaryTitle,
        exportCritiria:true,
        isCamelCase:['areaname'],
        schema: {
            title: "Total",
            area: "AREA",
            areaname: "AREA NAME",
            district: "DISTRICT",
            total: "TOTAL JOB COUNT",
            primary_role: "PRIMARY JOB ROLE COUNT",
            non_primary: "SECONDARY JOB ROLE COUNT"
        },
        footer:{
            sum:[{fieldKey:'title',label:'Total'},{fieldKey:'',label:''},{fieldKey:'total',sumBy:'total'},{fieldKey:'primary_role',sumBy:'primary_role'},{fieldKey:'non_primary',sumBy:'non_primary'}]
        }
    },
    isFooterRequired: true,
    isTableGap: true,
    footerConfig: {
        labelColumnText: 'Total',
        fields: ['total', 'primary_role', 'non_primary']
    },
     pageSizeOptions:{
        pageSize: [15, 25, 50, 100]
    },
    breadcrums: [{ level: 1, name: JobRSummaryTitle }]
}
